if (!window.customElements.get('fostr-carousel-component')) {
    class FostrCarouselComponent extends HTMLElement {
        constructor() {
            super();
            this.slider = this.querySelector('fostr-slider-component');

            this.controls = this.querySelector('fostr-carousel-controls-component');
        }

        currentSlideUpdated(index) {
            if (this.controls) {
                this.controls.currentSlideUpdated(index);
            }
        }
    }

    class FostrCarouselControlsComponent extends HTMLElement {
        currentSlideIndex = 0;
        constructor() {
            super();
            this.initialiseSlideIndicators();
            this.initialiseButtons();
        }

        initialiseButtons() {
            let nextButton = document.createElement('slide-button');
            nextButton.setAttribute("data-next", true);
            nextButton.onclick = () => {
                let numberOfSlides = this.parentElement.slider.slides.length;
                let slide = this.currentSlideIndex + 1;
                let next = this.currentSlideIndex + 1;
                if (slide >= numberOfSlides) {
                    next = 0;
                }
                this.goToSlide(next);
            }
            nextButton.innerHTML = ">";

            let previousButton = document.createElement('slide-button');
            previousButton.setAttribute("data-next", false);
            previousButton.onclick = () => {
                let numberOfSlides = this.parentElement.slider.slides.length;
                let slide = this.currentSlideIndex + 1;
                let previous = this.currentSlideIndex - 1;
                if (slide == 1) {
                    previous = numberOfSlides - 1;
                }
                this.goToSlide(previous);
            }
            previousButton.innerHTML = "<";

            this.appendChild(previousButton);
            this.appendChild(nextButton);
        }

        initialiseSlideIndicators() {
            this.parentElement.slider.slides.forEach((slide, index) => {
                this.addSlideIndicator(index);
            });
        }

        addSlideIndicator(index) {
            let indicator = document.createElement('slide-indicator');
            indicator.setAttribute("data-index", index);
            if (index == 0) {
                indicator.setAttribute("data-current", '');
            }
            indicator.onclick = () => this.goToSlide(index);
            this.appendChild(indicator);
        }

        currentSlideUpdated(slideIndex) {
            this.currentSlideIndex = parseInt(slideIndex);
            let indicators = this.querySelectorAll('slide-indicator');
            indicators.forEach((indicator, index) => {
                if (slideIndex == index) {
                    indicator.setAttribute("data-current", '');
                } else {
                    indicator.removeAttribute("data-current");
                }
            })
        }

        goToSlide(index) {
            this.parentElement.slider.scrollToSlideByIndex(index);
        }
    }

    class FostrSliderComponent extends HTMLElement {
        beingClicked = false;
        last_changed_frame = 0;
        isScrolling = false;
        hasScrolled = false;
        controller = new AbortController();
        bounced = 0;
        interval;
        lastXCoordinate;
        lastYCoordinate;
        currentSlide;

        constructor() {
            super();
            this.slides = this.querySelectorAll('fostr-slide-component');
            if (this.slides.length <= 0) {
                return;
            }

            this.currentSlide = this.slides.item(0);
            this.currentSlide.current = true;
            this.verticleSlider = this.parentNode.classList.contains('fostr-carousel--verticle');
            this.scrollAxis = this.verticleSlider ? 'top' : 'left';
            this.oppositeAxis = this.verticleSlider ? 'left' : 'top';
            this.axisOffset = this.verticleSlider ? 'offsetTop' : 'offsetLeft';
            this.scrollPostion = this.verticleSlider ? 'scrollTop' : 'scrollLeft';
            if (this.supportsSmoothScrolling()) {
                this.setupEventListeners();
                //this.interval = setInterval(() => this.bounceOnLoad(), 1000);
            } else {
                this.setupNoSmoothScroll();
            }
            this.watchVisibleSlides(); // Adds class to hide controles if all slides are visible
        }

        bounceOnLoad() {
            if (this.bounced < 2) {
                window.requestAnimationFrame(() => this.scroll({
                    [this.oppositeAxis]: 0,
                    [this.scrollAxis]: 100,
                    behavior: 'smooth'
                }));
                this.bounced++;
            } else {
                window.clearInterval(this.interval);
            }
        }

        setupNoSmoothScroll() {
            this.style.scrollSnapType = this.verticleSlider ? 'y mandatory' : 'x mandatory';
            this.style.webkitOverflowScrolling = 'touch';
            this.style.webkitScrollSnapType = this.verticleSlider ? 'y mandatory' : 'x mandatory';

            this.slides.forEach(slide => {
                slide.style.scrollSnapAlign = 'center';
            });

            this.addEventListener('mousedown', event => this.mouseDownEvent(event), true);
            this.addEventListener('mouseup', event => this.mouseUpEvent(event), true);
            this.addEventListener('mouseleave', event => this.mouseLeaveEvent(event), true);
            if (this.verticleSlider) {
                this.addEventListener('mousemove', event => this.mouseMoveEventY(event), true);
            } else {
                this.addEventListener('mousemove', event => this.mouseMoveEventX(event), true);
            }
        }

        setupEventListeners() {
            this.addEventListener('mousedown', event => this.mouseDownEvent(event), true);
            this.addEventListener('mouseup', event => this.mouseUpEvent(event), true);
            this.addEventListener('mouseleave', event => this.mouseLeaveEvent(event), true);
            this.addEventListener("scroll", event => this.scrollEvent(event), {
                signal: this.controller.signal
            });
            if (this.verticleSlider) {
                this.addEventListener('mousemove', event => this.mouseMoveEventY(event), true);
            } else {
                this.addEventListener('mousemove', event => this.mouseMoveEventX(event), true);
            }
        }

        scrollEvent(event) {
            this.controller.abort();
            this.controller = new AbortController();
            this.hasScrolled = false;
            this.waitForScrollEnd().then(() => this.scrollToCurrentSlide());
        }

        supportsSmoothScrolling() {
            const body = document.body;
            const scrollSave = body.style.scrollBehavior;
            body.style.scrollBehavior = 'smooth';
            const hasSmooth = getComputedStyle(body).scrollBehavior === 'smooth';
            body.style.scrollBehavior = scrollSave;
            return hasSmooth;
        }

        waitForScrollEnd() {
            return new Promise((resolve) => {
                this.tick(0, this, resolve);
            });
        }

        tick(frames, component, resolve) {
            const lastCoordinate = component.verticleSlider ? 'lastYCoordinate' : 'lastYCoordinate';
            if (frames - component.last_changed_frame >= 10) {
                resolve();
            } else {
                if (component[component.scrollPostion] != component[lastCoordinate]) {
                    component.hasScrolled = true;
                    if (component[component.scrollPostion] < component[lastCoordinate]) {
                        component.isScrollingAxis = true;
                    } else {
                        component.isScrollingAxis = false;
                    }
                    component.last_changed_frame = frames;
                    component.lastYCoordinate = component[component.scrollPostion];
                }
                requestAnimationFrame(component.tick.bind(null, frames + 1, component, resolve));
            }
        }

        mouseDownEvent(event) {
            this.beingClicked = true;
            this.style.cursor = "grab";
            if (!this.supportsSmoothScrolling()) {
                this.style.scrollSnapType = 'none';
                this.style.webkitOverflowScrolling = 'none';
                this.style.webkitScrollSnapType = 'none';
            }


            event.preventDefault();
        }

        mouseUpEvent(event) {
            this.beingClicked = false;
            this.style.cursor = "";
            if (!this.supportsSmoothScrolling()) {
                this.style.scrollSnapType = this.verticleSlider ? 'y mandatory' : 'x mandatory';
                this.style.webkitOverflowScrolling = 'touch';
                this.style.webkitScrollSnapType = this.verticleSlider ? 'y mandatory' : 'x mandatory';
            }
        }

        mouseMoveEventX(event) {
            if (this.beingClicked) {
                this.scrollLeft -= event.movementX;
            }
        }

        mouseMoveEventY(event) {
            if (this.beingClicked) {
                this.scrollTop -= event.movementY;
            }
        }

        mouseLeaveEvent(event) {
            if (!this.supportsSmoothScrolling()) {
                this.style.scrollSnapType = this.verticleSlider ? 'y mandatory' : 'x mandatory';
                this.style.webkitOverflowScrolling = 'touch';
                this.style.webkitScrollSnapType = this.verticleSlider ? 'y mandatory' : 'x mandatory';
            }
            this.beingClicked = false;
        }

        scrollToCurrentSlide() {
            if (this.hasScrolled) {
                this.getSlideToScrollTo();
                let computedPadding = parseInt(window.getComputedStyle(this, null).getPropertyValue(`padding-${this.scrollAxis}`));
                this.scroll({
                    [this.oppositeAxis]: 0,
                    [this.scrollAxis]: this.currentSlide[this.axisOffset] - computedPadding,
                    behavior: 'smooth'
                });
                this.parentElement.currentSlideUpdated(this.currentSlide.getAttribute('data-index'));
                this.addEventListener("scroll", event => this.scrollEvent(event), {
                    signal: this.controller.signal
                });
            }
        }

        scrollToSlideByIndex(index) {
            let computedPadding = parseInt(window.getComputedStyle(this, null).getPropertyValue(`padding-${this.scrollAxis}`));
            this.scroll({
                [this.oppositeAxis]: 0,
                [this.scrollAxis]: this.slides[index][this.axisOffset] - computedPadding,
                behavior: 'smooth'
            });
            this.parentElement.currentSlideUpdated(this.currentSlide.getAttribute('data-index'));
        }

        getSlideToScrollTo() {
            let slideFound = false;
            let indexFound;
            const clientSize = this.verticleSlider ? 'clientHeight' : 'clientWidth';
            this.slides.forEach((slide, index) => {
                slide.current = false;
                if (this.isScrolling) {
                    if ((slide[this.axisOffset] + (slide[clientSize] * .75)) >= this[this.scrollPostion] && !slideFound) {
                        this.currentSlide = slide;
                        slideFound = true;
                        slide.current = true;
                        indexFound = index;
                    }
                } else {
                    if ((slide[this.axisOffset] + (slide[clientSize] / 4)) > this[this.scrollPostion] && !slideFound) {
                        this.currentSlide = this.slides[index];
                        slideFound = true;
                        slide.current = true;
                        indexFound = index;
                    }
                }
            });
        }

        watchVisibleSlides() {
            const observerCallback = (entries) => {
                const allVisible = entries.every(entry => entry.isIntersecting);
                if (allVisible) {
                    this.classList.add('all-slides-visible');
                } else {
                    this.classList.remove('all-slides-visible');
                }
            };

            const observer = new IntersectionObserver(observerCallback, {threshold: 1.0});
            this.slides.forEach(slide => {
            observer.observe(slide);
            });
        }
    }

    class FostrSlideComponent extends HTMLElement {
        current = false;
        index;
        constructor() {
            super();
        }
    }

    customElements.define('fostr-carousel-component', FostrCarouselComponent);
    customElements.define('fostr-slider-component', FostrSliderComponent);
    customElements.define('fostr-slide-component', FostrSlideComponent);
    customElements.define('fostr-carousel-controls-component', FostrCarouselControlsComponent);
}
